import { useEffect, useState } from 'react'

enum DeviceMedia {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
}

//TODO generate this automatically in the generator script
enum Breakpoints {
  mobileMinWidth = 360,
  mobileMaxWidth = 599,
  tabletMinWidth = 600,
  tabletMaxWidth = 959,
  desktopMinWidth = 960,
}

function debounce<T extends (...args: unknown[]) => unknown>(func: T, wait: number) {
  let timeout: NodeJS.Timeout | null = null

  return function (...args: Parameters<T>): void {
    // Use arrow function to maintain the context of 'this'
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      func(...args) // Use 'func' directly without 'apply'
    }, wait)
  }
}

export const useDeviceMedia = () => {
  const [device, setDevice] = useState<DeviceMedia | undefined>()
  const [screenWidth, setScreenWidth] = useState<number | undefined>()

  const calculateDevice = () => {
    const windowInnerWidth = window.innerWidth
    setScreenWidth(windowInnerWidth)
    if (windowInnerWidth <= Breakpoints.mobileMaxWidth) {
      setDevice(DeviceMedia.Mobile)
    } else if (windowInnerWidth <= Breakpoints.tabletMaxWidth) {
      setDevice(DeviceMedia.Tablet)
    } else {
      setDevice(DeviceMedia.Desktop)
    }
  }
  const debouncedCalculateDevice = debounce(calculateDevice, 100)

  useEffect(() => {
    calculateDevice()
    window.addEventListener('resize', debouncedCalculateDevice)
    return () => {
      // Clean up the event listener on unmount
      window.removeEventListener('resize', debouncedCalculateDevice)
    }
  }, [debouncedCalculateDevice])

  const isMobile = device === DeviceMedia.Mobile
  const isTablet = device === DeviceMedia.Tablet
  const isDesktop = device === DeviceMedia.Desktop

  return {
    isNotMobile: isTablet || isDesktop,
    isNotTablet: isMobile || isDesktop,
    isNotDesktop: isMobile || isTablet,
    isMobile,
    isTablet,
    isDesktop,
    screenWidth,
  }
}
